import React from "react";
import { Flex, Box, Image, Heading } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import TestDataToggle from "./TestDataToggle"; // 👈 Import the toggle

const Header = () => {
  return (
    <Flex
      as="header"
      align="center"
      justify="space-between"
      padding="1rem 2rem"
      background="linear-gradient(to right, #ffbf00, var(--primary-color))"
      color="white"
      boxShadow="md"
    >
      {/* Logo with dashboard link */}
      <Box>
        <Link to="/dashboard">
          <Image
            src="/assets/img/adminportalnocolor.png"
            alt="Admin Portal Logo"
            height="50px"
            _hover={{ cursor: "pointer", opacity: 0.85 }}
          />
        </Link>
      </Box>

      {/* Right side: Title + Toggle */}
      <Flex align="center" gap={6}>
        <Heading size="md" color="white">
          Admin Portal
        </Heading>
        <TestDataToggle /> {/* 🚀 Drop the toggle in here */}
      </Flex>
    </Flex>
  );
};

export default Header;
